import { Component, inject, Input } from '@angular/core';
import { StatefulService } from '@app/service/stateful.service';
import { SawDust } from '@cudirect/shared-ui-library';
import { CardInstance } from '@workflow/class/card.service';
import { FlowInstance } from '@workflow/class/flow.service';
import { PageInstance } from '@workflow/class/page.service';
import { StringVariableService } from '@workflow/service/string-variable/string-variable.service';

@Component({ template: '' })
export class ReviewBaseComponent {
  protected logger = inject(SawDust).withContext({ component: 'ReviewBaseComponent' });

  @Input() public card: CardInstance = {} as CardInstance;
  /** current workflow */
  @Input() public flow: FlowInstance;
  /** page */
  @Input() public page: PageInstance;

  @Input() public allowEdit = false;

  @Input() public editUrlFn: (page: PageInstance, flow: FlowInstance, card: CardInstance) => void;

  public statefulService = inject(StatefulService);

  constructor(public readonly stringVariableService: StringVariableService) {}

  public goToEdit(): void {
    if (this.editUrlFn) {
      this.statefulService.wrap('ss:edit-review-page').value = this.page?.config?.customPageType === 'legacy-review';
      this.editUrlFn(this.page, this.flow, this.card);
    }
  }

  get editRouteLink() {
    if (this.editUrlFn) {
      return null;
    }
    const path = this.page.config.path ? this.page.config.path : this.page.id;
    return [`/${this.flow.id}/${path}`.replace('-#', `/${this.page.pageIterationId}`)];
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public parseText(text: string): any {
    return this.stringVariableService.parse(text);
  }
}
